// src/lib/windgram/projection.js
import { scaleLinear } from 'd3-scale';
import { convertUnit } from './scales';

// Ports bundle line 1221-1234. Returns the y(altitudeMeters)→pixel scale plus
// the terrain bottom and (for split axes) the split altitude.
//
// terrain derivation (bundle-exact): a preliminary linear scale V maps
// [loAlt, alt] → [innerHeight, 0]. The terrain ceiling in metres is:
//   terrainMeters = max(0, ((base - loAlt) / (alt - loAlt)) * alt)
// When loAlt = 0 this simplifies to (base / alt) * alt = base.
// With real data (loAlt=100, base=627.9, alt=9000) → ≈533.8 m, not 627.9 m.
export function buildAltitudeScale({ innerHeight: u, base, alt, maxPBLH, splitAxis, units = {}, loAlt = 0 }) {
  const hgt = units.hgt; // undefined → convertUnit passthrough (metres)

  // Bundle-faithful terrain: project base onto the [loAlt, alt] → [0, alt] linear scale.
  const terrainMeters = Math.max(0, ((base - loAlt) / (alt - loAlt)) * alt);
  const t = convertUnit(terrainMeters, hgt);

  const top = convertUnit(alt, hgt);

  let y, splitPoint = null;
  if (!splitAxis) {
    y = scaleLinear().domain([t, top]).range([u, 0]);
  } else {
    const d = Math.max(t + 1000, Math.min(3000, Math.max(1000, convertUnit(maxPBLH, hgt))));
    splitPoint = d;
    y = d < top
      ? scaleLinear().domain([t, d, top]).range([u, u / 2, 0])
      : scaleLinear().domain([t, top]).range([u, 0]);
  }
  return { y, terrain: t, splitPoint, top };
}
